import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../hooks/utils.hooks";
import { useEffect } from "react";
import {
  Flex,
  Center,
  Heading,
  FormControl,
  Image,
  FormErrorMessage,
  Text,
  useToast,
  InputGroup,
  Box,
} from "@chakra-ui/react";
import Logo from "../components/Logo";
import PrimaryButton from "../components/PrimaryButton";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import loginImage from "../assets/login.png";
import { newPassword } from "../mutations/auth.mutations";
import PasswordInput from "../components/inputs/PasswordInput";
import StlLoader from "../components/StlLoader";

function NewPasswordPage() {
  const { token } = useQueryParams();
  const navigate = useNavigate();
  const methods = useForm();
  const toast = useToast();
  const onSubmit = async (data: FieldValues) => {
    if (data.password != data.repeatPassword) {
      methods.setError("password", {
        message: "Les deux mots de passe doivent être identiques",
      });
      methods.setError("repeatPassword", {
        message: "Les deux mots de passe doivent être identiques",
      });
      return;
    }
    try {
      await newPassword({
        password: data.password,
        token,
      });
      navigate("/password/new/done");
    } catch (err) {
      toast({
        title: "Change de mot de passe",
        description: "Erreur interne",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [navigate, token]);
  return (
    <Flex>
      <Box display={{ base: "none", lg: "block" }}>
        <StlLoader
          alternative={
            <Image
              src={loginImage}
              alt="Dan Abramov"
              h="100vh"
              w="50vw"
              display={{ base: "none", lg: "block" }}
            />
          }
        ></StlLoader>
      </Box>
      <Center w="100%">
        <Flex
          direction="column"
          alignItems="left"
          justifyContent={"center"}
          h="100vh"
          w="100%"
          px={{ base: "44px", md: "144px" }}
        >
          <Flex direction="column" alignItems="center">
            <Logo />
            <Heading
              fontWeight={600}
              fontSize="32px"
              lineHeight="48px"
              color="gray.900"
              whiteSpace="nowrap"
            >
              Nouveau mot de passe
            </Heading>
            <Text
              fontWeight={400}
              fontSize="20px"
              lineHeight="30px"
              color="gray.600"
              textAlign="center"
            >
              Définissez votre nouveau mot de passe
            </Text>
          </Flex>
          <FormProvider {...methods}>
            <form
              style={{ marginTop: "32px" }}
              onSubmit={methods.handleSubmit((data) => onSubmit(data))}
            >
              <FormControl
                mt="10px"
                isInvalid={!!methods.formState.errors.password}
              >
                <InputGroup size="md">
                  <PasswordInput
                    pr="4.5rem"
                    placeholder="Mot de passe"
                    {...methods.register("password", {
                      required: "Ce champ est obligatoire",
                      minLength: {
                        value: 8,
                        message:
                          "Le mot de passe doit faire au minimum 8 caractères.",
                      },
                    })}
                  />
                </InputGroup>
                <FormErrorMessage>
                  <>{methods.formState.errors?.password?.message}</>
                </FormErrorMessage>
              </FormControl>

              <FormControl
                mt="10px"
                isInvalid={!!methods.formState.errors.password}
              >
                <InputGroup size="md">
                  <PasswordInput
                    pr="4.5rem"
                    placeholder="Mot de passe"
                    {...methods.register("repeatPassword", {
                      required: "Ce champ est obligatoire.",
                      minLength: {
                        value: 8,
                        message:
                          "Le mot de passe doit faire au minimum 8 caractères.",
                      },
                    })}
                  />
                </InputGroup>
                <FormErrorMessage>
                  <>{methods.formState.errors?.repeatPassword?.message}</>
                </FormErrorMessage>
              </FormControl>

              <PrimaryButton mt="24px" type="submit">
                Changer de mot de passe
              </PrimaryButton>
            </form>
          </FormProvider>
        </Flex>
      </Center>
    </Flex>
  );
}

export default NewPasswordPage;
